export default __webpack_public_path__ + "static/media/1.5533df32.png";